//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/TransientObject.js";
import "../no/DisplayableObject.js";
let d=[[[0,"ApplyToAllFaces",1,0],[0,"ApplyToOwningParts",1,0],[0,"CurveEndPointColorOption",1,0],[0,"CurveEndPointSpecificColor",1,0],[0,"CurveEndPointStyle",1,0],[0,"EndPointDisplayState",1,0],[0,"FaceAnalysisMode",1,0],[0,"KnotDisplayState",1,0],[0,"NewColor",1,0],[0,"NewFont",1,0],[0,"NewLayer",1,0],[0,"NewTranslucency",1,0],[0,"NewWidth",1,0],[0,"PartiallyShaded",1,0],[0,"PointShowThrough",1,0],[0,"PointSymbol",1,0],[0,"PoleDisplayState",1,0],[0,"ShowObjectName",1,0]],[[["u_grid","v_grid"],"SetNewGrid",{},2,0],[["u_grid","v_grid"],"GetNewGrid",{},0,0],[["objects"],"Apply",{},1,0],[[],"Dispose",{},0,0]],[]];
SPLM.DisplayModification = class extends SPLM.TransientObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.DisplayModification";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.DisplayModification.CurveEndPointColorOptions = Object.freeze({
    "NoChange" : "NoChange", "CurveColor" : "CurveColor", "SpecificColor" : "SpecificColor"});

SPLM.DisplayModification.CurveEndPointStyles = Object.freeze({
    "NoChange" : "NoChange", "OpenCircle" : "OpenCircle", "FilledCircle" : "FilledCircle", "PlusSign" : "PlusSign", "Cross" : "Cross", "Point" : "Point", "Asterisk" : "Asterisk", "PoundSign" : "PoundSign", "FilledSquare" : "FilledSquare", "FilledTriangle" : "FilledTriangle", "FilledDiamond" : "FilledDiamond", "Centerline" : "Centerline"});

export default SPLM;